/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Plan_RetargetInputs */

const en_us2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets and reps in the plan`)
};

const pt_br2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries e repetições no plano`)
};

const es_419_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series y repeticiones en el plan`)
};

const pt_pt2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries e repetições no plano`)
};

const fr_fr2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries et répétitions du programme`)
};

const de_de2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze und Wdh. im Plan`)
};

const it_it2_offline_kind_plan_retarget = /** @type {(inputs: Offline_Kind_Plan_RetargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie e ripetizioni nella scheda`)
};

/**
* | output |
* | --- |
* | "Sets and reps in the plan" |
*
* @param {Offline_Kind_Plan_RetargetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_plan_retarget = /** @type {((inputs?: Offline_Kind_Plan_RetargetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Plan_RetargetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_plan_retarget(inputs)
	if (locale === "es-419") return es_419_offline_kind_plan_retarget(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_plan_retarget(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_plan_retarget(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_plan_retarget(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_plan_retarget(inputs)
	return en_us2_offline_kind_plan_retarget(inputs)
});
export { offline_kind_plan_retarget as "offline.kind_plan_retarget" }